import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=1bf63fbe&"
import script from "./ListTable.vue?vue&type=script&lang=ts&"
export * from "./ListTable.vue?vue&type=script&lang=ts&"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=1bf63fbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports